import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'

import { InactiveContent } from './InactiveContent'
import { concatStyles } from 'utils'

const BOX_STYLES = 'box-border m-0'

const INACTIVE_TEXT_STYLES =
  'font-body text-base text-blankslateinactivecontent'

const INACTIVE_TEXT_COMPACT_STYLES =
  'font-body text-sm text-blankslateinactivecontent font-light text-left'

export interface BlankSlateProps {
  color?: string
  icon?: IconDefinition
  message: string
  className?: string
}

export const BlankSlate: React.FC<BlankSlateProps> = ({
  color,
  icon,
  message,
  className,
}) => (
  <InactiveContent flexDirection="col" className={className}>
    <div className={concatStyles([BOX_STYLES])}>
      {icon ? <FontAwesomeIcon color={color} icon={icon} size="4x" /> : null}
      <p className={INACTIVE_TEXT_STYLES} style={{ color }}>
        {message}
      </p>
    </div>
  </InactiveContent>
)

export const CompactBlankSlate: React.FC<BlankSlateProps> = ({
  color,
  icon,
  message,
  className,
}) => (
  <InactiveContent flexDirection="row" className={className}>
    {icon ? (
      <div className={concatStyles([BOX_STYLES, 'my-auto mr-4'])}>
        <FontAwesomeIcon color={color} icon={icon} size="2x" />
      </div>
    ) : null}
    <p className={INACTIVE_TEXT_COMPACT_STYLES} style={{ color }}>
      {message}
    </p>
  </InactiveContent>
)

BlankSlate.displayName = 'Content.BlankSlate'
